<template>
    
    <div @click="closeModal()">
        <fa icon="envelope" class="text-xl"  />
        <span :class="[state.notifications > 0 ? 'text-sirit_blue-500 font-bold' : '' ]" class="text-md t-50"> ({{state.notifications}})</span> 
    </div>
</template>

<script lang="ts">
import axios from 'axios'
import {reactive, toRefs, watch} from 'vue';
import * as global from '@/api/global'

export default {
  name: 'NotificationsCount',
  props: {
    openModal: { type: Boolean, required: true, default: false },
  },
  emits: ['onFire'],
  setup (props: any, { emit } : any) {

    const state = global.state;

    interface comment_ {
      loading: Boolean
      comments: Number
    }

    let data = reactive<comment_>({
      loading: false,
      comments: 0,
    })

    let errors = reactive([{
        code: 16691464,
        msg: "1"
    }]);

    const closeModal = () => {
        emit("onFire")
    }

    const getCommentsCount = async () => {
      data.loading = true;
      const url =  process.env.VUE_APP_BASE_URL+`/client/${global.getClietIdSession()}/comments/count`;
      let response = null
      try {
        response = await axios.get(url,  {
            headers: {
                Authorization: `Bearer ${global.getToken()}`
            }
        })
      } catch (e: any) {
          response = e.response;
      }

      if(response.status== 200){ 
        data.comments = response.data;
        state.notifications = response.data.count;
      }else{
        if(response.status== 401){
              global.logout();
        }
        errors = response.data;
      }
      data.loading = false;
    }

    watch(() => state.readNotifications, () => {
      if(state.readNotifications){
        getCommentsCount();
      }
    })

    const refreshNotifications = () => {
      const interval = setInterval(() => {
          if(!state.readNotifications){
              getCommentsCount();
          }
      }, 50000);
      return () => clearInterval(interval); 
    }

    getCommentsCount();
    refreshNotifications();

    return {
      closeModal,
      getCommentsCount,
      errors,
      global,
      state,
      ...toRefs(data)
    }

  }

}

</script>
